import { messages } from "constants/message";
import { AlertType, SnackAlertInterface } from "./stepperModel";

export const steps = ['Upload', 'Criteria', 'Review', 'Results'];

export const apiFailObject: SnackAlertInterface = { open: true, type: AlertType.error, message: messages.api_failed_msg, timeout: 6000};
export const generalFunctionFailed: SnackAlertInterface = { open: true, type: AlertType.error, message: messages.error_message, timeout: 6000};